const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		children: {
			ZZ_YUSEN_M610010: {
				name: ['主管出勤紀錄表', '主管出勤紀錄表', '主管出勤紀錄表'],
				url: '/zz_yusen_m610010',
			},
		},
	},
};

module.exports = (paidMenu) => {
    return { ...paidMenu, ...custMenu };
};